import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

const CheckCircle = ({ animate, className }) => (
  <svg
    className={classNames('check-circle', className, { animate })}
    version="1.1"
    viewBox="0 0 130 130"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      className="path circle"
      cx="50%"
      cy="50%"
      fill="none"
      r="62"
      strokeMiterlimit="10"
      strokeWidth="6"
    />
    <polyline
      className="path check"
      fill="none"
      points="100.2,40.2 51.5,88.8 29.8,67.5 "
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="6"
    />
  </svg>
);

CheckCircle.propTypes = {
  animate: PropTypes.bool,
  className: PropTypes.string
};

export default CheckCircle;
